var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThankyou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19254",
    "data-name": "Group 19254",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 263.142,
    height: 228.666,
    viewBox: "0 0 263.142 228.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a41505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f18220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.584,
    y1: 0.92,
    x2: 0.32,
    y2: 0.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 3.397,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42b428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#b6872d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#c9b964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#d9c393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#e7d9ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#f1e7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#eff9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#fbfdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19253",
    "data-name": "Group 19253",
    transform: "translate(33.976)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33606",
    "data-name": "Path 33606",
    d: "M429.672,478.833A66.368,66.368,0,1,1,363.3,412.464,66.368,66.368,0,0,1,429.672,478.833Zm29.891,0A96.259,96.259,0,1,0,363.3,575.092,96.259,96.259,0,0,0,459.563,478.833Z",
    transform: "translate(-267.044 -382.573)",
    fill: "#f18220"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33607",
    "data-name": "Path 33607",
    d: "M372.24,581.48a93.711,93.711,0,1,1,93.711-93.711A93.817,93.817,0,0,1,372.24,581.48Zm0-162.628a68.917,68.917,0,1,0,68.917,68.917A68.994,68.994,0,0,0,372.24,418.852Z",
    transform: "translate(-275.981 -391.509)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33608",
    "data-name": "Path 33608",
    d: "M372.24,394.057A93.664,93.664,0,0,0,287.368,527.44a171.63,171.63,0,0,1,19.162-18.9A68.912,68.912,0,0,1,434.39,458q12.465-1.314,26.107-1.712A93.862,93.862,0,0,0,372.24,394.057Z",
    transform: "translate(-275.981 -391.509)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33609",
    "data-name": "Path 33609",
    d: "M450.593,482.814c10.039,7.587,13.874,8.655,22.275,20.111,13.732,18.725,11.71,26.475,15.783,30.039s22.741,6.449,35.47-9.843,32.585-61.266,58.042-88.25,37.337-34.791,44.973-38.864-16.561-3.206-64.151,34.621c-33.094,26.305-56.514,62.624-56.514,62.624s-6.619-19.856-21.384-33.094S433.919,470.213,450.593,482.814Z",
    transform: "translate(-406.534 -391.752)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 131.571,
    cy: 19.368,
    rx: 131.571,
    ry: 19.368,
    transform: "translate(0 189.929)",
    opacity: 0.5,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.ea66ae6a112011166a606d257c90a3df.svg";
export { ForwardRef as ReactComponent };